var _defs, _style, _path, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMillstoneLog({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    width: 28,
    height: 28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ellipse 56-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 22,
    height: 22,
    id: "img3",
    href: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjcwNzEgMjEuMjkyOUMxMS4zMTY2IDIxLjY4MzQgMTAuNjgzNCAyMS42ODM0IDEwLjI5MjkgMjEuMjkyOUwwLjcwNzEwNyAxMS43MDcxQzAuMzE2NTgzIDExLjMxNjYgMC4zMTY1ODEgMTAuNjgzNCAwLjcwNzEwNyAxMC4yOTI5TDEwLjI5MjkgMC43MDcxMDlDMTAuNjgzNCAwLjMxNjU4NSAxMS4zMTY2IDAuMzE2NTgzIDExLjcwNzEgMC43MDcxMDhMMjEuMjkyOSAxMC4yOTI5QzIxLjY4MzQgMTAuNjgzNCAyMS42ODM0IDExLjMxNjYgMjEuMjkyOSAxMS43MDcxTDExLjcwNzEgMjEuMjkyOVoiIGZpbGw9IiMyQjJCMzIiLz4KPC9zdmc+Cg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff;stroke: #81818c } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m14 27.5c-7.5 0-13.5-6-13.5-13.5c0-7.5 6-13.5 13.5-13.5c7.5 0 13.5 6 13.5 13.5c0 7.5-6 13.5-13.5 13.5z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Polygon 4",
    href: "#img3",
    transform: "matrix(1,0,0,1,3,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillstoneLog);
export default __webpack_public_path__ + "static/media/MillstoneLog.75c4b952.svg";
export { ForwardRef as ReactComponent };